import React from 'react'
import FormDialog from '../../../library/form/components/FormDialog';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel';
import FormRichText from '../../../library/form/components/FormRichText';
import FormTitle from '../../../library/form/components/FormTitle';
import FormSH from '../../../library/form/components/FormSH';

const ProfileMemEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '200px' }}
            formStyle={{ width: '640px' }} formTitle={<FormTitle formObject={formObject} value="Profile Address" />}
        >
            <ul className="uiHeaderTwoCol">
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "memType" }} value="Membership Type" />
                    </span>
                    <FormInput formObject={formObject} rowKey="" autofocus className=""
                        action={{ InputType: "ac", paramName: "memType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                    />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "memName" }} value="Membership Name" />
                    </span>
                    <FormInput formObject={formObject} rowKey="" className="uiInput"
                        action={{ InputType: "input", paramName: "memName" }}
                    />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "memNumber" }} value="Membership No" />
                    </span>
                    <FormInput formObject={formObject} rowKey="" className="uiInput"
                        action={{ InputType: "input", paramName: "memNumber" }}
                    />
                </li>
                <li>
                    <span className="uiLbl">
                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "club" }} value="Club" />
                    </span>
                    <FormInput formObject={formObject} rowKey="" id="addressTypeTxt" className=""
                        action={{ InputType: "ac", paramName: "club", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                    />
                    <FormSH formObject={formObject} rowKey=""
                        action={{ actionId: "new", paramName: "club",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                        >
                    </FormSH>
                </li>
                <li>
                    <div>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remarks" }} value="Remarks" />
                        </span>
                        <FormRichText formObject={formObject} rowKey="" rows="5" cols="82" className=""
                            action={{ paramName: "remarks" }} />
                    </div>
                </li>
            </ul>
        </FormDialog>
    )
}

export default withView(ProfileMemEditor, "proMem", "proMem")